import { Component, OnInit } from "@angular/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService, ConfirmationService } from "primeng/api";
import { IUser } from "app/shared/Domains/IUser";
import { AuthService } from "common/services/auth.service";
import { UntypedFormGroup } from "@angular/forms";
import { IRole } from "app/shared/Domains/role";
import { IService } from "app/services/models/service";
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: "app-training-sessions",
    templateUrl: "./training-sessions.component.html",
    styleUrls: ["./training-sessions.component.css"],
})
export class TrainingSessionsComponent implements OnInit {
    calendarPlugins = [dayGridPlugin, interactionPlugin];
    userForm: UntypedFormGroup;
    trainingSessionsDialog: boolean = false;
    classSessionsDialog: boolean = false;
    loading: boolean = false;
    user: IUser;
    role:IRole;
    trainingSessions: any[];
    events: any[] = [
    ];
    scheduleOptions: any = {
    };
    memberName: string;
    trainerName: string;
    trainingSessionId: string;
    memberPerformanceArray: any[];
    memberPerformance: any;
    excerciseOptions: any[];
    selectedexcerciseOptions: any;
    reschedule: boolean = false;
    allowGeneralReschedule: boolean = true;
    allowPastReschedule : boolean = true;
    allowFutureReschedule : boolean = false;
    allowPastAttendance: boolean = false;
    allowFutureAttendance: boolean = false;
    allowAttendance: boolean = true;
    allowReschedule: boolean = true;
    status: string;
    services: IService[];
    selectedDate: Date = new Date();
    minDate: Date = new Date();
    members: any[];
    classTrainerName: string;
    classTrainingSessionId: string;
    constructor(
        private LanguageService: LanguageService,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
    ) {
    }

    hideModal() {
        this.trainingSessionsDialog = false;
        this.classSessionsDialog = false;

    }

    ngOnInit() {
        var date = new Date();
        this.services=[];
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        this.getAllServices();
        this.scheduleOptions = {
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            defaultDate: date.toLocaleDateString(),
            height:'auto',
            displayEventTime: false,
            header: {
                left: "prev,next, today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
            },
            eventClick: (info) => {
                console.log('Event clicked:', info.event);
                this.handleEventClick(info.event);
            }
        };

        this.getTrainingSessions();
        this.getMemberPerformance();
        this.getExcerciseOptions();
        this.breadcrumbService.setItems([
            { label: 'Training Sessions', routerLink: '/training-sessions' },
          ]);
    }

    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("TrainingSessionsComponent", label);
      }
    getAllServices() {
        this.appServiceManager.get("branches/" + this.user.branch + "/services").subscribe(
          (res) => {
            if (res) {
              this.loading = false;
              this.services = res.response;
              console.log(res.response);
            } else {
              this.loading = false;
            }
          },
          (error) => {
            this.loading = false;
            console.log(error);
          }
        );
      }
    showDialog() {
        this.trainingSessionsDialog = true;
    }
    changeAttendedStatus(member) {
        if (!this.allowAttendance) {
            return;
        }
        member.attendedStatus = member.attendedStatus === 'ATTENDED' ? 'UNMARKED' : 'ATTENDED';
    }
    markClassAttendance(){
        if (!this.allowAttendance || !this.members || this.members.length === 0) {
            return;
        }
        for(let member of this.members){
            if (member.attendedStatus === "UNMARKED") {
                member.attendedStatus = "NO–SHOW";
            }
        }
        const url = `branches/${this.user.branch}/training-sessions/actions/mark-class-attendance`;
        const body = { members: this.members.map((m: any) => ({ id: m.id, attendedStatus: m.attendedStatus })) };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Attendance Marked', res);
            this.classSessionsDialog = false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }
    handleEventClick(event: any) {
        let today = new Date();
        this.reschedule = false;
        today.setHours(0, 0, 0, 0);
        const eventDate = new Date(event.start);
        eventDate.setHours(0, 0, 0, 0);

        const isPast = eventDate.getTime() < today.getTime();
        const isFuture = eventDate.getTime() > today.getTime();

        const eventStartDate = new Date(event.start);
        eventStartDate.setHours(0, 0, 0, 0);

        let minRescheduleDate = new Date(eventStartDate);
        minRescheduleDate.setDate(minRescheduleDate.getDate() + 1);
        minRescheduleDate.setHours(0, 0, 0, 0);

        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);

        if (minRescheduleDate.getTime() < tomorrow.getTime()) {
            minRescheduleDate = tomorrow;
        }

        if(event.extendedProps.type == "classTraining" || event.extendedProps.trainingType == "classTraining"){
            this.classTrainerName = event.extendedProps.trainerName;
            this.classTrainingSessionId = event.extendedProps.trainingSessionId;
            const eventStartDateOnly = new Date(eventStartDate.getFullYear(), eventStartDate.getMonth(), eventStartDate.getDate());
            const eventPkgId = event.extendedProps.trainerPackageId?._id || event.extendedProps.trainerPackageId;

            this.members = this.trainingSessions
                .filter(session => {
                    const sessionStartDate = new Date(session.startDate);
                    const sessionStartDateOnly = new Date(sessionStartDate.getFullYear(), sessionStartDate.getMonth(), sessionStartDate.getDate());
                    const pkgId = session.trainerPackageId?._id || session.trainerPackageId;

                    const matchPackage = (!eventPkgId || !pkgId) ? true : (String(pkgId) === String(eventPkgId));
                    const isClass = (session.sessionsType == "classTraining" || session.trainingType == "classTraining" || session.serviceType == "classTraining" || session.packageType == "classTraining");
                    const hasSubscriber = !!(session.subscriberName && session.subscriberName.trim() !== '');

                    return isClass && matchPackage && hasSubscriber && sessionStartDateOnly.getTime() === eventStartDateOnly.getTime();
                })
                .map(session => {
                    return { id: session._id, name: session.subscriberName, attendedStatus: session.status || 'UNMARKED' };
                });

            const isClassMarked = this.members.some(m => m.attendedStatus === 'ATTENDED' || m.attendedStatus === 'NO–SHOW');

            if (isPast) {
                this.allowReschedule = false;
                this.allowAttendance = false;
            } else if (isFuture) {
                this.allowReschedule = true;
                this.allowAttendance = false;
            } else {
                this.allowAttendance = true;
                this.allowReschedule = !isClassMarked;
            }
            this.minDate = minRescheduleDate;
            this.selectedDate = minRescheduleDate;
            this.classSessionsDialog = true;
        }
        else{
            const serviceObj = this.services.filter( service => service._id == event.extendedProps.serviceId )[0];

            if (serviceObj && serviceObj.permissions) {
                this.allowGeneralReschedule = serviceObj.permissions.reschedule?.generalReschedule;
                this.allowPastReschedule = serviceObj.permissions.reschedule?.pastReschedule;
                this.allowFutureReschedule = serviceObj.permissions.reschedule?.futureReschedule;
                this.allowPastAttendance = serviceObj.permissions.attendance?.pastAttendance;
                this.allowFutureAttendance = serviceObj.permissions.attendance?.futureAttendance;
            }

            this.memberName = event.title;
            this.trainerName = event.extendedProps.trainerName;
            this.trainingSessionId = event.extendedProps.trainingSessionId;
            this.selectedexcerciseOptions = event.extendedProps.selectedexcerciseOptions;
            this.memberPerformance = event.extendedProps.memberPerformance;
            this.status = event.extendedProps.status;

            const isSessionMarked = this.status === 'ATTENDED' || this.status === 'NO–SHOW';

            if (isPast) {
                this.allowAttendance = false;
                this.allowReschedule = false;
            } else if (isFuture) {
                this.allowAttendance = false;
                this.allowReschedule = true;
                if (this.allowGeneralReschedule === false || this.allowFutureReschedule === false) {
                    this.allowReschedule = false;
                }
            } else {
                this.allowAttendance = true;
                this.allowReschedule = !isSessionMarked;
                if (this.allowGeneralReschedule === false) {
                    this.allowReschedule = false;
                }
            }
            this.minDate = minRescheduleDate;
            this.selectedDate = minRescheduleDate;
            this.trainingSessionsDialog = true;
        }
    }

    markPresent(){
        if (!this.allowAttendance) {
            return;
        }
        const url = `branches/${this.user.branch}/training-sessions/${this.trainingSessionId}/actions/mark-present`;
        const body = { exerciseOptions: this.selectedexcerciseOptions, memberPerformance: this.memberPerformance , status: "ATTENDED" };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Attendance Marked', res);
            this.trainingSessionsDialog = false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }

    markAbsent(){
        if (!this.allowAttendance) {
            return;
        }
        const url = `branches/${this.user.branch}/training-sessions/${this.trainingSessionId}/actions/mark-absent`;
        const body = {  status: "NO–SHOW" };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Attendance Marked', res);
            this.trainingSessionsDialog = false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }

    rescheduleSession(){
        const chosenDate = new Date(this.selectedDate);
        chosenDate.setHours(0, 0, 0, 0);
        const minAllowed = new Date(this.minDate || new Date());
        minAllowed.setHours(0, 0, 0, 0);
        if (chosenDate < minAllowed) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Cannot reschedule to the same or previous date. Please select a next upcoming date.",
            });
            return;
        }
        const url = `branches/${this.user.branch}/training-sessions/${this.trainingSessionId}/actions/reschedule`;
        const body = {  date: this.selectedDate };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Date changed', res);
            this.trainingSessionsDialog = false;
            this.reschedule=false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Date changed failed', error);
            }
        );
    }
    rescheduleClassSession() {
        const chosenDate = new Date(this.selectedDate);
        chosenDate.setHours(0, 0, 0, 0);
        const minAllowed = new Date(this.minDate || new Date());
        minAllowed.setHours(0, 0, 0, 0);
        if (chosenDate < minAllowed) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Cannot reschedule to the same or previous date. Please select a next upcoming date.",
            });
            return;
        }
        this.members;
        const url = `branches/${this.user.branch}/training-sessions/${this.classTrainingSessionId}/actions/reschedule-class`;
        const body = {members: this.members.map((m: any) => ({ id: m.id })), date: this.selectedDate };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Date changed', res);
            this.classSessionsDialog = false;
            this.trainingSessionsDialog = false;
            this.reschedule = false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Date changed failed', error);
            }
        );
    }
    getTrainingSessions() {
        this.trainingSessions = [];
        this.loading = true;
        let url;
        if(this.role.name =='Trainer'){
        url = `branches/${this.user.branch}/training-sessions?trainerId=${this.user._id}`;
        }else{
        url = `branches/${this.user.branch}/training-sessions`;
        }
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.length > 0) {
                        this.trainingSessions = res;
                        this.events = [];
                        const addedClassEvents = new Set<string>();
                        this.trainingSessions.forEach(session => {
                            const startDateTime = new Date(session.startDate);
                            startDateTime.setHours(0, 0, 0, 0);
                            const endDateTime = new Date(session.startDate);
                            endDateTime.setHours(23, 59, 59, 999);
                            let color;
                            switch (session.status) {
                                case 'UNMARKED':
                                    color = 'blue';
                                    break;
                                case 'ATTENDED':
                                    color = 'green';
                                    break;
                                case 'NO–SHOW':
                                    color = 'red';
                                    break;
                                default:
                                    color = 'blue';
                            }
                            let event;
                            if (session.serviceType !== "selfService") {
                                if (session.sessionsType == "classTraining" || session.trainingType == "classTraining") {
                                    const pkgId = session.trainerPackageId?._id || session.trainerPackageId;
                                    const classKey = `${pkgId || session.trainerId || session.serviceId}_${startDateTime.getTime()}`;
                                    if (addedClassEvents.has(classKey)) {
                                        return;
                                    }
                                    addedClassEvents.add(classKey);

                                    const classMembers = this.trainingSessions.filter(classMember => {
                                        const classMemberDate = new Date(classMember.startDate);
                                        classMemberDate.setHours(0, 0, 0, 0);
                                        const pkg1 = classMember.trainerPackageId?._id || classMember.trainerPackageId;
                                        const pkg2 = session.trainerPackageId?._id || session.trainerPackageId;
                                        return (!pkg1 || !pkg2 || String(pkg1) === String(pkg2)) &&
                                            classMemberDate.getTime() === startDateTime.getTime() &&
                                            classMember.subscriberName && classMember.subscriberName.trim() !== '';
                                    });
                                    const allMembersPresent = classMembers.length > 0 &&
                                        classMembers.every(member => member.status === 'ATTENDED');
                                    const hasPresentMember = classMembers.some(member => member.status === 'ATTENDED');
                                    const allMembersAbsent = classMembers.length > 0 &&
                                        classMembers.every(member => member.status === 'NO–SHOW');
                                    if (allMembersPresent) {
                                        color = 'green';
                                    } else if (hasPresentMember) {
                                        color = 'yellow';
                                    } else if (allMembersAbsent) {
                                        color = 'red';
                                    } else {
                                        color = 'blue';
                                    }
                                    event = {
                                        title: "Class Training",
                                        start: startDateTime,
                                        end: endDateTime,
                                        trainerName: session.trainerName,
                                        serviceId: session.serviceId,
                                        trainingSessionId: session._id,
                                        trainerPackageId: session.trainerPackageId,
                                        memberPerformance: session.memberPerformance,
                                        selectedexcerciseOptions: session.exerciseOptions,
                                        status: session.status,
                                        type: session.sessionsType || session.trainingType || "classTraining",
                                        trainingType: session.trainingType || session.sessionsType || "classTraining",
                                        color: color,
                                    };
                                }
                                else {
                                    if (session.trainingType !== "classTraining" || session.trainingType == undefined) {
                                        event = {
                                            title: session.subscriberName,
                                            start: startDateTime,
                                            end: endDateTime,
                                            trainerName: session.trainerName,
                                            serviceId: session.serviceId,
                                            trainingSessionId: session._id,
                                            memberPerformance: session.memberPerformance,
                                            selectedexcerciseOptions: session.exerciseOptions,
                                            status: session.status,
                                            color: color,
                                        };
                                    }

                                }
                            }
                            if(event){
                                this.events.push(event);
                            }
                        });
                    } else {
                        this.trainingSessions = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getMemberPerformance(){
        this.memberPerformanceArray = [];
        this.appServiceManager
        .get(
            `branches/${this.user.branch}/training-attendances/reports/member-performance`
        )
        .subscribe(
            (res) => {
                if (res.length > 0) {
                    res.forEach((element) => {
                        this.memberPerformanceArray.push({ name1: element.name, code1: element.name });
                    });
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );

    }
    getExcerciseOptions(){
        this.excerciseOptions = [];
        this.appServiceManager
        .get(
            `branches/${this.user.branch}/training-attendances/actions/exercise-options`
        )
        .subscribe(
            (res) => {
                if (res.length > 0) {
                    res.forEach((element) => {
                        this.excerciseOptions.push({ name2: element.name, code2: element.name });
                    });
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );

    }


}
